import { EnumFondiAction } from './fondi_action.js'
import update from 'immutability-helper';

const EnumActions = EnumFondiAction;
//obj vuoto o null e proprietà da java.
const initialState = {
    listFondi: {},
    detailsFondi: {},
    compagnia: {},
    listaProdottiPerFondi:[],
    detailsLinea: {},
}

const fondi = (state, action) => {
    if (typeof state === 'undefined') {
        return initialState
    }

    let moduleName = "[FondiReducer.js]"
    switch (action.type) {
        case EnumFondiAction.FONDI_INITIALIZED:
            return initialState

        case EnumFondiAction.FONDI_LIST:
            return Object.assign({}, state, { listFondi: action.dati })

        case EnumFondiAction.FONDO_DETAILS:
            return Object.assign({}, state, { detailsFondi: action.dati })

        case EnumFondiAction.FONDI_UPDATE:
            return update(state, action.fondi
            );

        case EnumFondiAction.FONDI_HANDLE_CHANGE:
            return update(state, {
                detailsFondi: { $merge: action.dato }
            });

        case EnumFondiAction.LISTA_PRODOTTI_PER_FONDO:
            return Object.assign({}, state, { listaProdottiPerFondi: action.dati })

        case EnumFondiAction.detailsLinea:
            return Object.assign({}, state, { detailsLinea: action.dati })
        default:
            return state;
    }
}
export default fondi;